module.exports = __webpack_public_path__ + "static/media/euro_grey.336ebb7e.svg";